"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printError = exports.isIError = void 0;
function isIError(arg) {
    return !!(arg &&
        typeof arg === "object" &&
        arg["name"] !== undefined &&
        arg["message"] !== undefined);
}
exports.isIError = isIError;
function printError(error) {
    return error ? error.message : undefined;
}
exports.printError = printError;
//# sourceMappingURL=IError.js.map